import type { User } from "@prisma/client";
import { animals, colors, uniqueNamesGenerator } from "unique-names-generator";
import { generateFromEmail } from "unique-username-generator";

export const getUserDisplayName = (
  user: Pick<User, "id" | "name" | "username" | "email">,
) => {
  if (user.name) {
    return user.name;
  }

  if (user.username) {
    return user.username;
  }

  if (user.email) {
    return generateFromEmail(user.email);
  }

  return uniqueNamesGenerator({
    dictionaries: [colors, animals],
    seed: user.id,
  });
};
